/**
 * Created by razial on 2026-05-21.
 */

if (typeof RewardedPromoConditions === "undefined") {
    RewardedPromoConditions = {};
}

RewardedPromoConditions.completedOrders = function (value) {
    const orderManager = Merge2.current && Merge2.current.orderManager;
    return orderManager && orderManager.index >= value;
};
